import { lazy } from 'react';
import { useTranslation } from 'react-i18next';

import { IconaTutorial } from '@/components/tutorial/IconaTutorial';
import { StorageKey } from '@/lib/storage';

/**
 * Il livello del tutorial arriva SOLO da qui, con `lazy()`: il suo chunk si scarica quando si apre, e non esce nella build di produzione (l'icona la monta solo `HubBriscola`, dietro il confronto LETTERALE
 * del flag). L'annotazione PURE davanti a `lazy` e NECESSARIA: senza, `lazy(...)` a livello di modulo resta nell'entry anche se il componente e scartato, e il chunk esce in produzione.
 */
const Livello = /*#__PURE__*/ lazy(() => import('./TutorialBriscola').then((m) => ({ default: m.TutorialBriscola })));

/** L'icona «Come si gioca» della Hub della briscola (BRI-TUT): la zona comune, con la chiave del «visto» della briscola. */
export function IconaTutorialBriscola() {
  const { t } = useTranslation('briscola');
  return <IconaTutorial Livello={Livello} chiave={StorageKey.BriscolaTutorialVisto} nome={t('tutorial.icona.nome')} nuovo={t('tutorial.icona.nuovo')} />;
}
